export default {
    popupCustomStyle: {
		maxHeight: "95vh",
		display: "flex",
		flexDirection: "column",
		width: '50vw',
		maxWidth: '50vw',
		minHeight: '200px'
	},
    popupChildrenStyles: {
		maxHeight: "100%",
		padding: '50px',
		paddingTop: '10px',
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		justifyContent: 'space-between',
		flex: 1,
	},
    popupFooterButton: {
		display: 'flex',
		gap: '10px',
		alignItems: 'center',
		justifyContent: 'flex-end',
		paddingTop: '20px'
	},
	uploadContainerBodyCustomStyles: {
        minHeight: "210px",
    },
}